import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=1380eeb4&"
import script from "./FileSelector.vue?vue&type=script&lang=js&"
export * from "./FileSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports